import { GridFilterModel, GridRowId } from "@mui/x-data-grid-premium";
import { createSlice } from "@reduxjs/toolkit";
import VwKullaniciDTO from "src/models/Base/Auth/VwKullaniciDTO";
import VwVezneKullanicimapDTO from "src/models/Base/Yetki/VwVezneKullanicimapDTO";
import VwKimlikDTO from "src/models/Genel/VwKimlikDTO";
import VwPersonelDTO from "src/models/GenelTanimlar/VwPersonelDTO";
import KullaniciListesiAramaKriterleri from "src/models/KullaniciTanim/KullaniciListesiAramaKriterleri";
import VwRoltanimDTO from "src/models/Settings/Generals/VwRolTanimDTO";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";

interface IKullanici {
  searchHandler: boolean;
  aramaKriterleri: KullaniciListesiAramaKriterleri;
  activeRow: VwKullaniciDTO;

  yetkiKopyalaDialog: boolean;
  tabValue: number;
  kayitModu: string;
  kayitModuTab: number;
  degisiklikAlgilama: boolean;

  //Kullanıcı Bilgileri
  kimlikActiveRow: VwKimlikDTO;
  kimlikTabValue: number;
  personelActiveRow: VwPersonelDTO;
  kullaniciActiveRow: VwKullaniciDTO;
  hizliKullaniciActiveRow: VwKullaniciDTO;

  //Organizasyon
  organizasyonExpandedRows: Record<GridRowId, boolean>;
  organizasyonFilterModel: GridFilterModel;

  //Kullanıcı Rol
  kullaniciRolDialog: boolean;
  kullaniciRolActiveRow: VwRoltanimDTO;
  kullaniciRolDetayDialog: boolean;
  rolYetkiExpandedRows: Record<GridRowId, boolean>;
  rolYetkiFilterModel: GridFilterModel;

  //Kullanıcı Vezne
  kullaniciVezneDialog: boolean;
  kullaniciVezneActiveRow: VwVezneKullanicimapDTO;
};
const KullaniciSlice = createSlice<IKullanici, MapReducerPayloads<IKullanici, {
  setSearchHandler: boolean;
  setAramaKriterleri: KullaniciListesiAramaKriterleri;
  setActiveRow: VwKullaniciDTO;

  setYetkiKopyalaDialog: boolean;
  setTabValue: number;
  setKayitModu: string;
  setKayitModuTab: number;
  setDegisiklikAlgilama: boolean;

  //Kullanıcı Bilgileri
  setKimlikActiveRow: VwKimlikDTO;
  setKimlikTabValue: number;
  setPersonelActiveRow: VwPersonelDTO;
  setKullaniciActiveRow: VwKullaniciDTO;
  setHizliKullaniciActiveRow: VwKullaniciDTO;

  //Organizasyon
  setOrganizasyonExpandedRows: Record<GridRowId, boolean>;
  setOrganizasyonFilterModel: GridFilterModel;

  //Kullanıcı Rol
  setKullaniciRolDialog: boolean;
  setKullaniciRolActiveRow: VwRoltanimDTO;
  setKullaniciRolDetayDialog: boolean;
  setRolYetkiExpandedRows: Record<GridRowId, boolean>;
  setRolYetkiFilterModel: GridFilterModel;

  //Kullanıcı Vezne
  setKullaniciVezneDialog: boolean;
  setKullaniciVezneActiveRow: VwVezneKullanicimapDTO;
}>>({
  name: 'kullanici',
  initialState: {
    searchHandler: true,
    aramaKriterleri: new KullaniciListesiAramaKriterleri(),
    activeRow: new VwKullaniciDTO(),

    yetkiKopyalaDialog: false,
    tabValue: 1,
    kayitModu: "",
    kayitModuTab: 1,
    degisiklikAlgilama: false,

    //Kullanıcı Bilgileri
    kimlikActiveRow: new VwKimlikDTO(),
    kimlikTabValue: 1,
    personelActiveRow: new VwPersonelDTO(),
    kullaniciActiveRow: new VwKullaniciDTO(),
    hizliKullaniciActiveRow: new VwKullaniciDTO(),

    //Organizasyon
    organizasyonExpandedRows: {},
    organizasyonFilterModel: { items: [], quickFilterValues: [] },

    //Kullanıcı Rol
    kullaniciRolDialog: false,
    kullaniciRolActiveRow: new VwRoltanimDTO(),
    kullaniciRolDetayDialog: false,
    rolYetkiExpandedRows: {},
    rolYetkiFilterModel: { items: [], quickFilterValues: [] },

    //Kullanıcı Vezne
    kullaniciVezneDialog: false,
    kullaniciVezneActiveRow: new VwVezneKullanicimapDTO(),
  },
  reducers: {
    setSearchHandler: (state, action) => {
      state.searchHandler = action.payload;
    },
    setAramaKriterleri: (state, action) => {
      state.aramaKriterleri = action.payload;
    },
    setActiveRow: (state, action) => {
      state.activeRow = action.payload;
    },

    setYetkiKopyalaDialog: (state, action) => {
      state.yetkiKopyalaDialog = action.payload;
    },
    setTabValue: (state, action) => {
      state.tabValue = action.payload;
    },
    setKayitModu: (state, action) => {
      state.kayitModu = action.payload;
    },
    setKayitModuTab: (state, action) => {
      state.kayitModuTab = action.payload;
    },
    setDegisiklikAlgilama: (state, action) => {
      state.degisiklikAlgilama = action.payload;
    },

    setKimlikActiveRow: (state, action) => {
      state.kimlikActiveRow = action.payload;
    },
    setKimlikTabValue: (state, action) => {
      state.kimlikTabValue = action.payload;
    },

    setPersonelActiveRow: (state, action) => {
      state.personelActiveRow = action.payload;
    },
    setKullaniciActiveRow: (state, action) => {
      state.kullaniciActiveRow = action.payload;
    },
    setHizliKullaniciActiveRow: (state, action) => {
      state.hizliKullaniciActiveRow = action.payload;
    },

    setOrganizasyonExpandedRows: (state, action) => {
      state.organizasyonExpandedRows = action.payload;
    },
    setOrganizasyonFilterModel: (state, action) => {
      state.organizasyonFilterModel = action.payload;
    },

    setKullaniciRolDialog: (state, action) => {
      state.kullaniciRolDialog = action.payload;
    },
    setKullaniciRolActiveRow: (state, action) => {
      state.kullaniciRolActiveRow = action.payload;
    },
    setKullaniciRolDetayDialog: (state, action) => {
      state.kullaniciRolDetayDialog = action.payload;
    },
    setRolYetkiExpandedRows: (state, action) => {
      state.rolYetkiExpandedRows = action.payload;
    },
    setRolYetkiFilterModel: (state, action) => {
      state.rolYetkiFilterModel = action.payload;
    },

    setKullaniciVezneDialog: (state, action) => {
      state.kullaniciVezneDialog = action.payload;
    },
    setKullaniciVezneActiveRow: (state, action) => {
      state.kullaniciVezneActiveRow = action.payload;
    },
  },
});
export default KullaniciSlice;